/* eslint-disable react/prop-types */
import {
  BrandAlsoAcceptedAt,
  BrandDescription,
  BrandMoreOnRaise,
  BrandRating,
  SellingRate,
  BrandRedemptionDetails,
  BrandTrackAndSell,
  ReferralBanner
} from "components/UI/molecules";
import { useAppContext } from "context/app-context";
import "./index.scss";

export const BrandDetailsSidebar = ({ brandDetails, brandTerms }) => {
  const {
    name,
    productSourceId,
    description,
    rating,
    ratingCount,
    ratingUpdatedAt,
    sellingRate,
    cardTypeDescription,
    path,
    acceptedAt,
    isApple
  } = brandDetails;
  const {
    sessionInfo: { isLoggedIn }
  } = useAppContext();

  return (
    <aside className="details-sidebar">
      <BrandDescription
        brandName={name}
        description={description}
        defaultMaximumLines={6}
        isApple={isApple}
      />
      <BrandRedemptionDetails
        terms={brandTerms}
        card={cardTypeDescription}
        name={name}
        isApple={isApple}
      />
      <BrandRating
        id={productSourceId}
        rating={{
          value: rating,
          count: ratingCount,
          updatedAt: ratingUpdatedAt
        }}
      />
      <hr className="sidebar-hr" />
      <SellingRate sellingRate={sellingRate} />
      <BrandTrackAndSell
        name={name}
        isLoggedIn={isLoggedIn}
        productSourceId={productSourceId}
      />
      <ReferralBanner />
      <BrandMoreOnRaise name={name} path={path} isLoggedIn={isLoggedIn} />
      {!!acceptedAt?.length && <BrandAlsoAcceptedAt acceptedAt={acceptedAt} />}
    </aside>
  );
};
